export default {
    dev: {
        serverUrl: '/jdeco-oa', // 测试接口域名
        weatherUrl: '/caiyun',
        tdtUrl: '/tdt'
    },
    test: {
        serverUrl: '/jdeco-oa', // 测试接口域名
        weatherUrl: '/caiyun',
        tdtUrl: '/tdt'
    },
    pred: {
        serverUrl: '/jdeco-oa', // 测试接口域名
        weatherUrl: '/caiyun',
        tdtUrl: '/tdt'
    },
    prod: {
        serverUrl: '/jdeco-oa', // 测试接口域名
        weatherUrl: '/caiyun',
        tdtUrl: '/tdt'
    }
}
